var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"color":"#F56C6C"},attrs:{"type":"text"},on:{"click":_vm.deleteList}},[_vm._v("删除")])}
var staticRenderFns = []

export { render, staticRenderFns }